import { render, staticRenderFns } from "./ConfermaOrdine.vue?vue&type=template&id=d6646da4&"
import script from "./ConfermaOrdine.vue?vue&type=script&lang=js&"
export * from "./ConfermaOrdine.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports